export const germanText = {
  immediately_available: "Sofort verfügbar",
  legally_valid: "Rechtsgültig für 10 Jahre",
  energy_certificate: "Energieausweis nach GEG",
  consumption_certificate: "Verbrauchsausweis",
  need_certificate: "Bedarfsausweis",
  step_1: "Schritt 1",
  step_2: "Schritt 2",
  step_3: "Schritt 3",
  step_4: "Schritt 4",
  step_5: "Schritt 5",
  step_6: "Schritt 6",
  step_7: "Schritt 7",
  step_8: "Schritt 8",
  building_info: "Gebäudedaten",
  heating_info: "Heizung",
  heat_water_info: "Warmwasser",
  vacancy_info: "Leerstand",
  property_info: "Weitere Gebäudedaten",
  property_address: "Adresse",
  certificate: "Vorschau ",
  billing_delivery_address: "Rechnungs- und Lieferadresse",
  save_resume_later: "Speichern und später fortsetzen",
  next: `Weiter`,
  previous: "Zurück",
  google_review: `Google-Bewertung`,
  our_payment_methods: `Unsere Zahlungsarten`,
  energy_certificates: `Energieausweise`,
  create_consumption_certificate: `einen Verbrauchsausweis erstellen`,
  create_needs_certificate: `ein Bedarfsausweis erstellen`,

  build_photo_info: `Falls vorhanden, können Sie ein Foto des Gebäudes hochladen (Außenansicht). Dieses Bild wird auf dem Energieausweis angezeigt.`,
  order_type: `Art der Bestellung`,
};

export const consumCertGerText = {
  building_data: "Gebäudedaten",
  provided_information: "Bitte stellen Sie die benötigten Information zu Verfügung",
  close: "Schließen",
  occasion: "Anlass",
  occasion_error: `Anlass ist erforderlich`,
  occasion_paragraph: `Wenn Sie den Energieausweis für eine Finanzierung oder einen Kreditantrag benötigen, wählen Sie bitte als Ausstellungsgrund „Andere“. Energieausweise mit den Ausstellungsgründen „Neubau“ oder „Modernisierung“ können nicht nach § 80 Satz 1 und 2 GEG bestellt werden.`,
  postal_code: "Postleitzahl",
  postal_code_error: `Ungültige Postleitzahl`,
  building_type: `Gebäudetyp`,
  building_type_error: `Gebäudetyp ist erforderlich`,
  building_type_paragraph: `Für gemischt genutzte Gebäude empfehlen wir einen Bedarfsausweis, da dieser genauere Ergebnisse liefert.`,
  year_of_construction: "Jahr der Errichtung",
  year_of_construction_error: `Das Jahr muss zwischen 1850 und `,
  number_of_apartments: "Anzahl der Wohnungen",
  number_of_apartments_error:
    "Die Anzahl der Wohnungen ist als Zahl anzugeben.",
  number_of_apartments_paragraph: `Da Energieausweise nur für das gesamte Gebäude und nicht für einzelne Wohnungen ausgestellt werden können, sind Angaben zu allen Wohnungen des Gebäudes erforderlich. Bitte zählen Sie Einliegerwohnungen als separate Wohneinheiten. Bei Einfamilienhäusern, wenn keine weiteren Wohnungen im Gebäude vorhanden sind, wählen Sie bitte 1 Wohneinheit.`,
  eMail: `E-Mail`,
  eMail_error: `Ungültige E-Mail Adresse`,
  eMail_para_1:
    "Bitte geben Sie eine gültige E-Mail-Adresse an, damit wir Sie kontaktieren können, wenn wir Fragen zu Ihren Angaben haben.",
  eMail_para_2:
    "Sie erhalten auch die Auftragsbestätigung und die Rechnung über die von Ihnen angegebene E-Mail-Adresse.",
  number_of_floors: "Anzahl der Etagen (ohne Keller und Dachgeschoss)",
  number_of_floors_error: "Die Anzahl der Stockwerke ist als Zahl anzugeben.",
  number_of_floors_paragraph: ``,
  floor_to_ceiling_height: "Durchschnittliche Geschosshöhe (inkl. Deckenstärke)",
  floor_to_ceiling_height_error:
    "Die Höhe vom Boden bis zur Decke (in Metern) wird als Zahl benötigt.",
  floor_to_ceiling_height_paragraph: ``,
  is_there_heated_basement: `Gibt es ein beheiztes Untergeschoss`,
  yes: "Ja",
  no: "Nein",
  Please_provide_proper_information:
    "Bitte stellen Sie die benötigten Information zu Verfügung",
  heating_system_are_installed: `Wie viele Heizungsanlagen sind installiert?`,
  energy_sources: ` Energiequellen `,
  energy_sources_error: `Eine Energiequelle ist erforderlich.`,
  energy_sources_paragraph: `Bitte wählen Sie hier Ihre Hauptenergiequelle`,
  unit: `Einheit`,
  unit_error: `Unit ID ist erforderlich.`,
  unit_para_1: `Bitte geben Sie die korrekte Verbrauchseinheit des Energieträgers/Brennstoffs ein.`,
  unit_para_2: `Diese können Sie in der Regel auf Ihrer Heizkostenabrechnung finden.`,
  name_of_provider_line: `Wenn Sie den Primärenergiefaktor Ihres Energieversorgers nicht kennen, teilen Sie uns bitte den Namen Ihres Versorgers mit. `,
  name_of_provider_line1: `Sie können hier Notizen hinterlassen.`,
  date: `Datum`,
  date_paragraph: `Um einen Verbrauchsausweis zu beantragen, müssen die Verbrauchswerte der letzten drei Jahre vorliegen, d.h. der erste Abrechnungszeitraum muss mindestens drei Jahre zurückliegen. Tragen Sie hier den Monat und das Jahr des Beginns des ersten Abrechnungszeitraums ein.`,
  consumption_from_this: "Verbrauch für ",
  vacancy_from_this: "Leerstandsquote von ",

  consumption_from_this_error: `Das Feld „Verbrauch“ ist ungültig. Es muss eine positive Zahl sein und darf keine Buchstaben oder Sonderzeichen wie „e“, „-“ oder „+“ enthalten.`,
  consumption_from_this_para_1:
    "Bitte geben Sie hier den Gesamtenergieverbrauch für jeden Zeitraum an. Ein Abrechnungszeitraum ist immer ein Jahr lang.",
  consumption_from_this_para_2:
    "Bei Mehrfamilienhäusern sollten Sie den Gesamtenergieverbrauch des gesamten Gebäudes angeben, da sich Energieausweise immer auf das gesamte Gebäude beziehen.",
  consumption_from_this_para_3:
    "Wenn es sich um ein Blockheizkraftwerk (BHKW) handelt, geben Sie bitte nur die erzeugte Wärmemenge (ohne Strom) an.",
  included_heating_system: `Ist der Warmwasserverbrauch in den Angaben zum Energieverbrauch enthalten?`,
  included_heating_system_paragraph: `Bitte geben Sie hier an, ob der Warmwasser-Energieverbrauch bereits in dem oben angegebenen Verbrauch enthalten ist oder nicht. Sie können den Warmwasser-Energieverbrauch auch separat angeben.`,
  consumption_is_unknown: `Der Verbrauch ist unbekannt`,
  percentage_share_of_hot_water: `Prozentualer Anteil von Warmwasser`,
  percentage_share_of_hot_water_paragraph: `Geben Sie hier den Anteil der Warmwasserversorgung an. Der Standardwert ist 18%.`,
  vacancy_info_paragraph: `Wenn das Objekt nicht während des gesamten Zeitraums voll bewohnt war, können Sie hier die Leerstandsquote in Prozent angeben.`,
  vacancy_info_para_1: `Bitte geben Sie die Leerstandsquote in % für ein ganzes Jahr und für das gesamte Gebiet an.`,
  vacancy_info_para_2: `Berechnung der Leerstandsquote: Sie addieren die Tage des Leerstands über ein Jahr und teilen diese durch 365. Dann multiplizieren Sie den Wert mit 100 und Sie erhalten den Prozentsatz.`,
  vacancy_info_para_3: `Beispiel: Wenn die Immobilie innerhalb von 12 Monaten 3 Tage lang leer steht, wären dies ca. 8 %. Berechnung: 30 / 365 * 100 = 8,1%`,
  heating_system_installed_on1: `Jahr, in dem das `,
  heating_system_installed_on2: `Heizsystem installiert wurde`,
  heating_system_installed_on_error: `Das Jahr muss zwischen 1903 und 2024 liegen.`,
  heating_system_installed_on_paragraph: `Das Baujahr der Heizungsanlage finden Sie im Abgasmessprotokoll, in der Betriebsanleitung, auf dem Typenschild, im Abnahmeprotokoll usw. Wenn Sie Fernwärme nutzen, geben Sie bitte das Baujahr der Fernwärmeübergabestation an. Wenn Ihr Kessel modernisiert wurde,  geben Sie bitte das Jahr der Modernisierung an. Das Jahr, in dem der Brenner modernisiert wurde, ist nicht relevant. Wenn Sie mehrere Geräte haben, geben Sie bitte das überwiegende Baujahr an.`,
  type_of_ventilation: `Art der Belüftung`,
  type_of_ventilation_paragraph: `Wie wird das Gebäude belüftet? Beispiele für Lüftungsanlagen ohne Wärmerückgewinnung sind Abluftanlagen in fensterlosen Räumen wie Badezimmern. Lüftungsanlagen mit Wärmerückgewinnung sind zum Beispiel zentrale oder dezentrale Zu- und Abluftanlagen, die mit Wärmetauschern ausgestattet sind.`,
  exhaust_air_system: `Abluftsystem`,
  without_heat_recovery: `Lüftungsanlage ohne Wärmerückgewinnung`,
  with_heat_recovery: `Lüftungsanlage mit Wärmerückgewinnung`,
  shaft_ventilation: `Schachtbelüftung`,
  windows_ventilation: `Fensterlüftung`,
  living_space: `Wohnfläche (nicht Gebäudefläche)`,
  living_space_error: `Bitte geben Sie eine gültige Wohnfläche (positive Zahl) ein.`,
  living_space_paragraph: `Der Energieausweis ist immer auf das jeweilige Gebäude bezogen. Wir bitten Sie daher, die Wohnfläche des gesamten Gebäudes (ohne Keller) in Quadratmetern anzugeben. Anhand dieser Angaben wird die Nutzfläche des Gebäudes im Energieausweis automatisch berechnet.`,
  insulation_regulation_met: `Wurde die Wärmeschutzverordnung von 1977 eingehalten?`,
  thermal_heading:
    "Bitte prüfen Sie, ob das Gebäude den Wärmeschutzstandard von 1977 erfüllt. Die Kriterien sind erfüllt, wenn Ihr Gebäude:",
  thermal_point1:
    "1. Überwiegend Außenwände hat, die entweder aus 24 cm dickem Bimsstein, Porenbeton, Blocksteinen bestehen, 38 cm Kalksandstein mit mindestens 6 cm Dämmung oder zweischaliges Mauerwerk mit 8 cm Dämmung aufweisen.",
  thermal_point2:
    "2. Fenster aus Holz oder Kunststoff mit Doppel- oder Isolierverglasung besitzt.",
  thermal_point3:
    "3. Ein gedämmtes Dach hat, wobei die Dämmung entweder 18 cm auf den Sparren, 15 cm zwischen den Sparren oder 8 cm auf dem Dachboden beträgt.",
  thermal_point4:
    "4. Bei einem unbeheizten Keller eine 5,5 cm dicke Dämmung der Kellerdecke vorhanden ist (bei beheizten Kellern oder ohne Keller ist keine Dämmung erforderlich).",
  thermal_point5:
    "Wenn alle Bedingungen erfüllt sind, wählen Sie bitte die Checkbox an. Diese Angaben helfen uns, Sie korrekt für einen Verbrauchs- oder Bedarfsausweis zu kategorisieren.",
  insulation_regulation_met_paragraph: ``,
  building_part: `Gebäudeteil`,
  building_part_error: `Bitte wählen Sie ein Gebäudeteil aus.`,
  building_part_para_1: `Im lokalen Sinne gilt ein Gebäude nur dann als gemischtes Gebäude, wenn zwei getrennte Energieausweise ausgestellt werden müssen. Dies ist der Fall, wenn die Gewerbe- und Wohnflächen in einem engeren Verhältnis als 90% und 10% zueinander stehen. In allen anderen Fällen muss „Wohngebäude“ gewählt werden.`,
  building_part_para_2: `Außerdem kann ein gemeinsamer Energieausweis ausgestellt werden, wenn sich die Heizungsanlage nicht wesentlich unterscheidet.`,
  building_part_para_3: `Wir stellen auch Energieausweise für Nichtwohngebäude aus. Bitte wenden Sie sich an uns per Mail (info@greenox-group.de).`,
  property_have_basement: `Verfügt die Immobilie über ein Untergeschoss?`,
  lies_below_ground_floor: `Was verbirgt sich unter dem Erdgeschoss?`,
  unheated_basement: `Unbeheizter Keller`,
  heated_cellar: `Beheizter Keller`,
  no_floor_slab: `Kein Keller vorhanden/ Bodenplatte`,
  renewables_energy_used: `Wird erneuerbare Energie genutzt?`,
  do_you_use: `Welche Art von erneuerbaren Energie nutzen Sie?`,
  solar_theramal_energy: `Solarthermie`,
  photovoltaics: `Photovoltaik`,
  heat_pump: `Wärmepumpe`,
  biomass: `Biomasse`,
  renewables_energy_used_for: `Verwendung der erneuerbaren Energie`,
  heating: `Heizung`,
  hotwater: `Warmwasser`,
  electricity: `Elektrizität`,
  optional_information_about_equipment: `Möchten Sie weitere Informationen über die Ausstattung Ihres Hauses geben?`,
  sun_protection: `Welchen Sonnenschutz gibt es?`,
  sun_protection_error: `Bitte wählen Sie eine Sonnenschutzoption.`,
  glare_protection: `Kein Sonnen-/Blendschutz`,
  flare_protection: `Sonnen- und/oder Blendschutz (Rollläden, Jalousien), automatisch betrieben`,
  only_glare_protection: `Nur Blendschutz (meist im Bürogebäude)`,
  light_directing: `Nur Blendschutz, lichtlenkend (meist in Bürogebäuden)`,
  insulation_glazing: `Verfügt die Immobilie über eine Wärmedämmung/Isolierverglasung?`,
  attic_insulation: `Ist das Dach oder der Dachboden isoliert?`,
  house_number: `Straße und Hausnummer`,
  house_number_error: `Straße ist erforderlich`,
  house_number_para_1: `Bitte geben Sie die Adresse des Gebäudes an, für das der Energieausweis erstellt werden soll.`,
  house_number_para_2: `Im nächsten Schritt können Sie die Rechnungs- und Lieferadresse eingeben.`,
  postcode: `Postleitzahl`,
  postcode_error: `Postleitzahl ist erforderlich`,
  postcode_para_1: `Bitte geben Sie die Adresse des Gebäudes an, für das der Energieausweis erstellt werden soll.`,
  postcode_para_2: `Im nächsten Schritt können Sie die Rechnungs- und Lieferadresse eingeben.`,
  location: `Stadt`,
  location_error: `Stadt ist erforderlich`,
  location_para_1: `Bitte geben Sie die Adresse des Gebäudes an, für das der Energieausweis erstellt werden soll.`,
  location_para_2: `Im nächsten Schritt können Sie die Rechnungs- und Lieferadresse eingeben.`,
  upload_building_photo: `Gebäudefoto hochladen`,
  upload_building_photo_error: `Bitte laden Sie eine gültige Bilddatei hoch (JPG, PNG, GIF, WEBP).`,
  upload_building_photo_max_size_error: `Dieses Bild ist zu groß. Es darf höchstens 10 MB groß sein.`,
  drag_drop_upload: `Bild hier reinziehen oder hochladen`,
  energy_certificate_available: `Ihr Energieausweis ist jetzt verfügbar`,
  energy_certificate_available_para_1: `Hier ist Ihre Vorschau des Energieauseises mit den genannten Daten. Bitte beachten Sie, dass es sich hierbei nicht um den endgültigen Energieausweis handelt. Sie erhalten den registrierten und rechtsgültigen Energieausweis, nachdem wir Ihre Angaben geprüft haben.`,
  energy_certificate_available_para_2: `Bitte überprüfen Sie noch einmal alle Daten und klicken Sie dann auf `,
  energy_certificate_available_box_1: `GEG-konform · 10 Jahre gültig`,
  energy_certificate_available_box_2: `Zertifizierte Energieberater`,
  energy_certificate_available_box_3: `Sofortversand: PDF & Rechnung`,
  energy_certificate_available_box_4: `Sichere Zahlung`,
  energy_certificate_available_box_5: `GREENOX GmbH`,
  energy_certificate_available_pdf_check_your_details: `Bitte prüfen Sie Ihre Angaben. Nach Abschluss der Zahlung erhalten Sie Ihren unterschriebenen und offiziell registrierten Energieausweis inkl. QR-Code.`,
  energy_certificate_available_pdf_progress_bar: `95 % abgeschlossen – nur noch 1 Schritt`,
  energy_certificate_available_pdf_sidebar_section_1_title: `Das erhalten Sie mit dem Kauf`,
  energy_certificate_available_pdf_sidebar_section_1_check_1: `✅ Offizieller Energieausweis (PDF) mit QR-Code`,
  energy_certificate_available_pdf_sidebar_section_1_check_2: `✅ Manuelle Prüfung durch zertifizierte Energieberater`,
  energy_certificate_available_pdf_sidebar_section_1_check_3: `✅ Rechnung & Nachweis für Behörden`,
  energy_certificate_available_pdf_sidebar_section_1_check_4: `✅ Speicherung & kostenlose Korrektur bei Bedarf`,
  energy_certificate_available_pdf_sidebar_section_2_title: `Ihr Energieverbrauch wirkt zu hoch?`,
  energy_certificate_available_pdf_sidebar_section_2_para_part_1: `Keine Sorge – das ist häufig der Fall. Die Berechnung nutzt realistische Durchschnittswerte nach GEG.`,
  energy_certificate_available_pdf_sidebar_section_2_para_part_2: `Wir prüfen jeden Ausweis manuell`,
  energy_certificate_available_pdf_sidebar_section_2_para_part_3: `bevor er registriert wird.`,
  energy_certificate_available_pdf_sidebar_section_2_info: `Bei Altbauten ohne Sanierungen sind Werte über 150 kWh/m²a normal. Baujahr, Heizung und Dämmung beeinflussen den Kennwert stark.`,
  energy_certificate_available_pdf_sidebar_section_2_checkbox_1: `Der berechnete Wert erscheint mir realistisch`,
  energy_certificate_available_pdf_sidebar_section_2_checkbox_2: `Ich finde den Wert zu hoch – bitte prüfen Sie das`,
  energy_certificate_available_pdf_sidebar_section_2_checkbox_3: `Ich möchte eine Rückmeldung vor der finalen Ausstellung`,
  energy_certificate_available_pdf_sidebar_section_2_feedback: `Ihre Hinweise (optional)`,
  i_reviewed_entries: `Ich habe meine Eingaben überprüft und keine Fehler gefunden.`,
  order_type: `Auftragsart`,
  order_type_paragaraph: `Bitte wählen Sie aus, ob Sie die Bestellung als Privatperson oder als Unternehmen veranlassen. Wenn Sie als Gewerbetreibender mit einer Umsatzsteuer-Identifikationsnummer bestellen, wählen Sie „Gewerblich“. Wenn Sie als Unternehmer ohne Umsatzsteuer-Identifikationsnummer bestellen, wählen Sie entweder „Privat“ oder „Gewerblich ohne Umsatzsteuer-Identifikationsnummer“.`,
  private_owners: `Privateigentümer`,
  commercial: `Gewerblich`,
  commercial_ustId: `Gewerblich (ohne USt.ID)`,
  phone_number: `Telefonnummer`,
  first_name: `Vorname`,
  surname: `Nachname`,
  billing_house_number: `Straße & Hausnummer`,
  billing_house_number_para_1: `Bitte geben Sie die Adresse an, die auf der Rechnung erscheinen soll. Wenn Sie die optionale Postzustellung wählen, senden wir Ihren Energieausweis auch an diese Adresse.`,
  billing_house_number_para_2: `Sollten Sie abweichende Adressen für den Versand und die Rechnung benötigen, geben Sie bitte die zusätzliche Adresse im Kommentarfeld an oder wenden Sie sich direkt an unseren Kundenservice.`,
  billing_house_number_para_3: `Wenn Ihre Adresse im Ausland liegt, können Sie auch eine ausländische Adresse angeben. Wir liefern auch ins Ausland.`,
  company_name: `Name des Unternehmens`,
  VAT_ID: `UMSATZSTEUER-ID`,
  common_error: `Dieses Feld darf nicht leer sein`,
  add_on_services: `Zusätzlicher Service`,
  certificate_packages_title: `Zertifikat-Pakete`,
  certificate_packages_description: `Kaufen Sie mehrere Zertifikate im Voraus und sparen Sie!`,
  postal_dispatch_invoices: `Postversand von Energieausweis & Rechnung`,
  express_exhibition_today: `Express-Ausstellung heute`,
  advanced_verification: `Erweiterte Verifizierung (empfohlen)`,
  free_correction_option: `Korrekturmöglichkeit, wenn falsche Informationen entdeckt werden`,
  experts_explain: `Persönliches 30 Minuten Telefonat, um Fragen zu beantworten`,
  delivery_method: `Liefermethode des Energieausweises (Liefermethode der ID-Karte)`,
  delivery_method_2: `Versandart des Ausweises (gedruckte Kopie per Post und digital per E-Mail)`,
  order_summary: `Zusammenfassung der Bestellung`,
  energy_performance_certificate: `Energieausweis`,
  certificate_residential_build: `Verbrauchsausweis für Wohngebäude`,
  i_agree_text: `Ich bin mit den Allgemeinen Geschäftsbedingungen einverstanden und habe die Bestimmungen zum Datenschutz und zur Widerrufsbelehrung zur Kenntnis genommen`,
  terms_conditions: `Bedingungen und Konditionen`,
  total: `Insgesamt`,
  order_now: `Jetzt bestellen`,
  cooling_system: `Gibt es ein Kühlsystem?`,
  save_changes: "Änderungen speichern",
  invalid_postal_code: "Ungültige Postleitzahl",
  invalid_year_of_construction_error:
    "Ungültiges Jahr, bitte geben Sie einen numerischen Wert ein.",
  invalid_contain: "sollte kein '-', 'e' oder '+' enthalten.",
  invalid_vatId: "keine gültige Mehrwertsteuernummer",
  energy_required: "Angabe der Energiequelle erforderlich",
  unitId_required: "Angabe der Einheit ist erforderlich.",
  invalid_consum:
    "„Das Feld „Verbrauch“ ist ungültig. Es muss eine positive Zahl ohne „e“, „-“ oder „+“ sein.",
  year_val: "Das Jahr muss zwischen",
  and: "und",
  pos_number: "Bitte geben Sie eine gültige Wohnfläche (positive Zahl) ein.",
  building_part: "Bitte wählen Sie ein Gebäudeteil aus.",
  sun_prot: "Bitte wählen Sie eine Sonnenschutzoption.",
  street_error: "Straße ist erforderlich",
  post_val: "Die Postleitzahl muss zwischen 3 und 5 Ziffern haben.",
  con_info: "Die Verbrauchsinformation muss ein nicht leeres Array sein.",
  per_pos: "Der Prozentsatz muss eine positive Zahl sein.",
  less_great:
    "Der Wert sollte nicht weniger als 25% und nicht mehr als 175% der",
  i_e: "d.h. den Wert im ersten Verbrauchsfeld.",
  select_error: "Bitte wählen Sie die Anzahl der installierten Heizsysteme",
  Occasion_head: "Anlass",
  Occasion_desc: `Wenn Sie den Energieausweis für eine Finanzierung oder einen Kreditantrag benötigen, wählen Sie bitte als Ausstellungsgrund „Andere“. Energieausweise mit den Ausstellungsgründen „Neubau“ oder „Modernisierung“ können nicht nach § 80 Satz 1 und 2 GEG bestellt werden.`,
  build_head: "Gebäude Typ",
  build_desc: `Für gemischt genutzte Gebäude empfehlen wir einen Bedarfsausweis, da dieser genauere Ergebnisse liefert.`,
  num_aprt: "Anzahl der Wohnungen",
  num_aprtdesc: `Da Energieausweise nur für das gesamte Gebäude und nicht für einzelne Wohnungen ausgestellt werden können, sind Angaben zu allen Wohnungen des Gebäudes erforderlich. Bitte zählen Sie Einliegerwohnungen als separate Wohneinheiten. Bei Einfamilienhäusern, wenn keine weiteren Wohnungen im Gebäude vorhanden sind, wählen Sie bitte 1 Wohneinheit.`,
  num_floor: "Anzahl der Etagen (ohne Keller und Dachgeschoss)",
  num_floor_desc:
    "Kellergeschosse (auch wenn diese nur teilweise im Erdreich sind) und Geschosse mit Dachschrägen sind vorerst nicht zu berücksichtigen und werden separat abgefragt",
  email: "E-Mai",
  e_para_1: `Bitte geben Sie eine gültige E-Mail-Adresse an, damit wir Sie kontaktieren können, wenn wir Fragen zu Ihren Angaben haben.`,
  e_para_2: `Sie erhalten auch die Auftragsbestätigung und die Rechnung über die von Ihnen angegebene E-Mail-Adresse.`,
  floor_ceiling: "Boden bis zur Decke Höhe",
  floor_ceiling_desc:
    "Die Geschosshöhe ist der Abstand von der Oberfläche eines Bodens bis zur Oberfläche des darüberliegenden Bodens",
  Energy_h: "Energiequellen",
  Energy_d: "Bitte wählen Sie hier Ihre Hauptenergiequelle",
  date_h: "Dat",
  date_d: `Um einen Verbrauchsausweis zu beantragen, müssen die Verbrauchswerte der letzten drei Jahre vorliegen, d.h. der erste Abrechnungszeitraum muss mindestens drei Jahre zurückliegen. Tragen Sie hier den Monat und das Jahr des Beginns des ersten Abrechnungszeitraums ein.`,
  date_d2: ` Um einen Verbrauchsausweis zu beantragen, müssen die Verbrauchswerte der letzten zwei Jahre vorliegen, d.h. der zweite Abrechnungszeitraum muss mindestens zwei Jahre zurückliegen. Tragen Sie hier den Monat und das Jahr des Beginns des zweiten Abrechnungszeitraums ein `,
  date_d3: `Um einen Verbrauchsausweis zu beantragen, müssen die Verbrauchswerte der letzten ein Jahre vorliegen, d.h. der dritte Abrechnungszeitraum muss mindestens ein Jahr zurückliegen. Tragen Sie hier den Monat und das Jahr des Beginns des dritten Abrechnungszeitraums ein  
`,
  date_d4: `„Um einen Verbrauchsausweis zu beantragen, müssen die Verbrauchswerte der letzten drei Jahre vorliegen, d.h. der vierte Abrechnungszeitraum muss mindestens drei Jahre zurückliegen. Tragen Sie hier den Monat und das Jahr des Beginns des vierten Abrechnungszeitraums ein.`,

  consmCount_h: "Verbrauch",
  consmCount_d1: `Bitte geben Sie hier den Gesamtenergieverbrauch für jeden Zeitraum an. Ein Abrechnungszeitraum ist immer ein Jahr lang.`,
  consmCount_d2: `Bei Mehrfamilienhäusern sollten Sie den Gesamtenergieverbrauch des gesamten Gebäudes angeben, da sich Energieausweise immer auf das gesamte Gebäude beziehen.`,
  consmCount_d3: `Wenn es sich um eine Kraft-Wärme-Kopplungsanlage (BHKW) handelt, geben Sie bitte nur die erzeugte Wärmemenge (ohne Strom) an.`,
  unit_h: "Einheit",
  unit_d1: `Bitte geben Sie die korrekte Verbrauchseinheit des Energieträgers/Brennstoffs ein.`,
  unit_d2: `Diese können Sie in der Regel auf Ihrer Heizkostenabrechnung finden.`,
  include_h: "Warmwasserverbrauch",
  include_d: `Bitte geben Sie hier an, ob der Warmwasserverbrauch bereits in dem oben angegebenen Verbrauch enthalten ist oder nicht. Sie können den Warmwasserverbrauch auch separat angeben.`,
  system_h: "Anteil Warmwasser am Gesamtverbrauch",
  system_d: `Geben Sie hier den Wert für den prozentualen Warmwasserverbrauch an dem Gesamtverbrauch an. Der Standardwert beträgt 18%.`,
  vacancy_h: "Prozentsatz des Leerstands",
  vacancy_d1: `Bitte geben Sie die Leerstandsquote in % für ein ganzes Jahr und für das gesamte Gebiet an.`,
  vacancy_d2: `Berechnung der Leerstandsquote Sie addieren die Leerstandsquote über die Monate und teilen diese durch 12. Dann multiplizieren Sie den Wert mit 100 und Sie erhalten den Prozentsatz.`,
  vacancy_d3: `Beispiel: Wenn die Immobilie innerhalb von 12 Monaten 3 Monate lang leer steht, wären dies 25 %. Berechnung: 3 / 12 * 100 = 25%`,
  install_h: "Baujahr der Heizungsanlage",
  install_d: `Das Baujahr der Heizungsanlage finden Sie im Abgasmessprotokoll, in der Betriebsanleitung, auf dem Typenschild, im Abnahmeprotokoll usw. Wenn Sie Fernwärme nutzen, geben Sie bitte das Baujahr der Fernwärmeübergabestation an. Wenn Ihr Kessel modernisiert wurde, geben Sie bitte das Jahr der Modernisierung an. Das Jahr, in dem der Brenner modernisiert wurde, ist nicht relevant. Wenn Sie mehrere Geräte haben, geben Sie bitte das überwiegende Baujahr an.`,
  ventilation_h: "Art der Belüftung",
  ventilation_d: `Wie wird das Gebäude belüftet? Beispiele für Lüftungsanlagen ohne Wärmerückgewinnung sind Abluftanlagen in fensterlosen Räumen wie Badezimmern. Lüftungsanlagen mit Wärmerückgewinnung sind zum Beispiel zentrale oder dezentrale Zu- und Abluftanlagen, die mit Wärmetauschern ausgestattet sind.`,
  livingSpace_h: "Wohnfläche (nicht Gebäudefläche)",
  livingSpace_d: `Der Energieausweis ist immer auf das jeweilige Gebäude bezogen. Wir bitten Sie daher, die Wohnfläche des gesamten Gebäudes (ohne Keller) in Quadratmetern anzugeben. Anhand dieser Angaben wird die Nutzfläche des Gebäudes im Energieausweis automatisch berechnet.`,
  building_h: "Gebäudeteil",
  building_d1: `Im lokalen Sinne gilt ein Gebäude nur dann als gemischtes Gebäude, wenn zwei getrennte Energieausweise ausgestellt werden müssen. Dies ist der Fall, wenn die Gewerbe- und Wohnflächen in einem engeren Verhältnis als 90% und 10% zueinander stehen. In allen anderen Fällen muss „Wohngebäude“ gewählt werden.`,
  building_d2: `Außerdem kann ein gemeinsamer Energieausweis ausgestellt werden, wenn sich die Heizungsanlage nicht wesentlich unterscheidet.`,
  building_d3: `Wir stellen derzeit keine Energieausweise für Nichtwohngebäude aus.`,
  thermal_h: "Wurde die Wärmeschutzverordnung von 1977 eingehalten?",
  number_h: "Straße und Hausnummer",
  number_d1: `Bitte geben Sie die Adresse des Gebäudes an, für das der Energieausweis erstellt werden soll.`,
  number_d2: `Im nächsten Schritt können Sie die Rechnungs- und Lieferadresse eingeben.`,
  Postcode_h: "Postleitzahl",
  Postcode_d1: `Bitte geben Sie die Adresse des Gebäudes an, für das der Energieausweis erstellt werden soll`,
  Postcode_d2: `Im nächsten Schritt können Sie die Rechnungs- und Lieferadresse eingeben.`,
  Location_h: "Stadt",
  Location_d1: `Bitte geben Sie die Adresse des Gebäudes an, für das der Energieausweis erstellt werden soll.`,
  Location_d2: `Im nächsten Schritt können Sie die Rechnungs- und Lieferadresse eingeben.`,
  order_h: "Typ bestellen",
  order_d: `Bitte wählen Sie aus, ob Sie den Antrag als Privatperson oder als Unternehmen einreichen. Wenn Sie als Gewerbetreibender mit einer Umsatzsteuer-Identifikationsnummer bestellen, wählen Sie „Gewerblich“. Wenn Sie als Unternehmer ohne Umsatzsteuer-Identifikationsnummer bestellen, wählen Sie entweder „Privat“ oder „Gewerblich ohne Umsatzsteuer-Identifikationsnummer“.`,
  address_d1: `Bitte geben Sie die Adresse an, die auf der Rechnung erscheinen soll. Wenn Sie die optionale Postzustellung wählen, senden wir Ihren Energieausweis auch an diese Adresse.`,
  address_d2: `Sollten Sie abweichende Adressen für den Versand und die Rechnung benötigen, geben Sie bitte die zusätzliche Adresse im Kommentarfeld an oder wenden Sie sich direkt an unseren Kundenservice.`,
  address_d3: `Wenn Ihre Adresse im Ausland liegt, können Sie auch eine ausländische Adresse angeben. Wir liefern auch ins Ausland.`,
  close_btn: "Schließen",
  continue: "„ Weiter“.",
  prolonged: "Gab es einen längeren Leerstand?",
  including: "inkl. 19% MwSt.",
  energy_certificate_needed:
    "Nach Ihren Angaben ist für Ihr Gebäude ein Energiebedarfsausweis erforderlich. Wenn Sie das Gebäude jedoch gemäß der Wärmeschutzverordnung saniert haben, haben Sie auch die Möglichkeit, einen Energieverbrauchsausweis zu beantragen. Dazu wählen Sie bitte die entsprechende Option „Gebäudesanierung vorhanden“.",
  needed_info: "(Ihre Eingaben werden übertragen)",
  needed_certificate_button: "Bedarfsausweis erstellen",
  thermal_checkbox:
    "Wärmeschutzverordnung von 1977 wird vom Objekt eingehalten",
  notes_documents_button: "Anmerkungen & Dokumente",
  total: "Insgesamt",
  order_summary: "Zusammenfassung der Bestellung",
  energy_performance_text: "Energieausweis",
  i_agree_text:
    "Ich bin mit den Allgemeinen Geschäftsbedingungen einverstanden und habe die die Bestimmungen zum Datenschutz und zur Widerrufsbelehrung zur Kenntnis genommen",
  mail_sent: "Link an Ihre E-Mail geschickt",
  not_valid_num: "keine gültige Telefonnummer",
  cannot_be_empty: "Dieses Feld darf nicht leer sein",
  field_required: "Dieses Feld ist erforderlich",
  consum_residential_buildings: "Verbrauchsausweis für Wohngebäude",
  privacy_policy: "Datenschutzbestimmungen",
  aggree: "Ich akzeptiere die ",
  proceed: "Bitte akzeptieren Sie die Datenschutzbestimmungen, um fortzufahren",
  notes: "Anmerkungen",
  send_mail:
    "Wir senden Ihnen dann einen Link an Ihre E-Mail-Adresse, mit dem Sie genau dort weitermachen können, wo Sie aufgehört haben",
  additional_document: "Zusätzliche Dokumente",
  document_additional_text:
    "Hier haben Sie die Möglichkeit, weitere Dokumente hochzuladen, die für die Erstellung des Energieausweises hilfreich sein können.",
  document_secondary_text:
    "Da die Struktur des Gebäudes nicht standardisiert ist, wird empfohlen, alle Details der Struktur und Fotos des Gebäudes hochzuladen (falls keine Baupläne vorhanden sind)",
  document_info:
    "Alle zusätzlichen Informationen, die für die Erstellung des Energieausweises hilfreich sind, können hier hinzugefügt werden.",
  before_you_go: "Bevor Sie gehen...",
  send_by_mail: "Link per E-Mail versenden:",
  send_mail_desc:
    "Wir senden Ihnen dann einen Link an Ihre E-Mail-Adresse, mit dem Sie genau dort weitermachen können, wo Sie aufgehört haben.",
  send_link: "Link senden",
  cancel: "Abbrechen",
  submit_details: "Details einreichen",
  company_name: "Name des Unternehmens",
  vat_id: "MwSt ID",
  to: "bis",
  sqm: "m²",

  not_found: "Seite nicht gefunden",
  something_wrong: `Irgendetwas ist schief gelaufen.<br/>
Bitte versuchen Sie es nach einiger Zeit erneut.`,
  support:
    "Wenn das Problem weiterhin besteht, wenden Sie sich bitte an den Support.",
  back_step: "Zurück zu Schritt 1",
  partially_heated: "Ist ein Stockwerk nur teilweise beheitzt?",
  year: "liegen",
  link_head: "Probleme beim Hochladen von Dateien?",
  link_para:
    "Wenn Sie Schwierigkeiten beim Hochladen Ihrer Dateien haben oder Ihre Dokumente so groß sind, dass Sie uns einen Link zu einem Cloud-Dienst (wie Dropbox, Google Drive, OneDrive) schicken möchten, steht Ihnen nichts im Wege. Fügen Sie einfach den Link unten hinzu und geben Sie den Zugang mit der E-Mail-ID „info@greenox-group.de“ frei.",
  year_of_construction: "Baujahr",
  year_of_construction_paragraph: `Bitte geben Sie das ursprüngliche Baujahr an, in dem das Gebäute gebaut wurde. `,
  below_ground: `Was liegt unter dem Erdgeschoss? `,
  below_ground_info1: `Bitte geben Sie an, ob es einen Keller gibt oder ob dieser beheizt ist. `,
  below_ground_info2: `Beheizt bedeutet, dass es in den meisten Zimmern Heizkörper gibt. Es spielt keine Rolle, ob Sie sie einschalten oder nicht.`,
  cooling_s: `Gibt es ein Kühlsystem? `,
  cooling_s_info: `Bitte geben Sie an, ob Ihre Immobilie im Sommer gekühlt wird. Dies könnte zum Beispiel durch eine Klimaanlage geschehen.`,

  ellusion: "Ist das Dach oder der Dachboden isoliert?",
  ellusion_info:
    "Bitte geben Sie die Dicke der Dachisolierung in cm an. Wenn das Dach oder der Dachboden nicht isoliert ist, geben Sie 0 ein.",
  email_start: `Indem Sie fortfahren, akzeptieren Sie unsere`,
  height_val: `Die maximale Höhe muss kleiner als oder gleich 5 sein.`,
  payment_done: "Zahlung erfolgt",
  sub_total: "Zwischensumme",
  total: "Insgesamt",
  discount: "Coupon-Rabatt",
  copon_codes: "Coupon-Codes",
  off: "Aus",
  apply: "Anwenden",
  applied: "Angewandt",
  not_exist: "Ungültiger Gutscheincode",
  select_option: "Bitte wählen Sie mindestens eine Option",
  required_field_error: `Dieses Feld ist erforderlich`,
  number_of_air_conditioning_systems: "Anzahl der zu überprüfenden Klimaanlagen",
  cooling_capacity: "Kühlleistung",
  next_inspection_date: "Datum der nächsten Inspektion"

};

export const needCertificateGerText = {
  step_1: "Schritt 1",
  step_2: "Schritt 2",
  step_3: "Schritt 3",
  step_4: "Schritt 4",
  step_5: "Schritt 5",
  step_6: "Schritt 6",
  step_7: "Schritt 7",
  step_8: "Schritt 8",
  building_info: "Gebäudedaten",
  structure_details: `Gebäudeform`,
  building_component: `Gebäudekomponenten`,
  heat_generator_details: `Details zum Wärmeerzeuger`,
  Please_provide_proper_information:
    "Bitte stellen Sie die benötigten Information zu Verfügung",
  property_address: "Adresse der Immobilie",
  file_upload: `Datei-Upload`,
  certificate: "Vorschau",
  billing_delivery_address: "Rechnungs- und Lieferadresse",
  building_data: "Gebäudedaten",
  provided_information: "Bitte stellen Sie die benötigten Information zu Verfügung",
  occasion: "Anlass",
  occasion_error: `Anlass ist erforderlich`,
  occasion_paragraph: `Benötigen Sie den Energieausweis für eine Finanzierung oder einen Kreditantrag? Dann wählen Sie bitte „Andere“ als Ausstellungsgrund. Energieausweise mit dem Ausstellungsgrund „Neubau“ oder „Modernisierung“ können nicht gemäß § 80 GEG erstellt werden.`,
  postal_code: "Postleitzahl",
  postal_code_error: `Ungültige Postleitzahl`,
  building_type: `Gebäudetyp`,
  building_type_error: `Gebäudetyp ist erforderlich`,
  building_type_paragraph: `Für gemischt genutzte Gebäude empfehlen wir einen Bedarfsausweis, da dieser genauere Ergebnisse liefert.
  „Doppelhaus“ hinzufügen
  Zwei aneinandergebaute, getrennt nutzbare Wohneinheiten mit eigener Heizung.`,
  number_of_apartments: "Anzahl der Wohneinheiten",
  number_of_apartments_error:
    "Die Anzahl der Wohnungen ist als Zahl anzugeben.",
  number_of_apartments_paragraph: `Da Energieausweise nur für das gesamte Gebäude und nicht für einzelne Wohnungen ausgestellt werden können, sind Angaben zu allen Wohnungen des Gebäudes erforderlich. Bitte zählen Sie Einliegerwohnungen als separate Wohneinheiten. Bei Einfamilienhäusern, wenn keine weiteren Wohnungen im Gebäude vorhanden sind, wählen Sie bitte "1" als Wohneinheit.`,
  year_of_construction: "Baujahr",
  year_of_construction_error: `Das Jahr muss zwischen 1850 und 2024 liegen.`,
  year_of_construction_paragraph: `Baujahr an, in dem das Gebäute gebaut wurde.`,
  no_of_floors: `Anzahl der Etagen (ohne Keller und Dachgeschoss)`,
  eMail: `E-Mail`,
  eMail_error: `Ungültige E-Mail Adresse`,
  eMail_para_1:
    "Bitte geben Sie eine gültige E-Mail-Adresse an, damit wir Sie kontaktieren können, wenn wir Fragen zu Ihren Angaben haben.",
  eMail_para_2:
    "Sie erhalten auch die Auftragsbestätigung und die Rechnung über die von Ihnen angegebene E-Mail-Adresse.",
  number_of_floors: "Anzahl der Etagen (ohne Keller und Dachgeschoss)",
  number_of_floors_error: "Die Anzahl der Stockwerke ist als Zahl anzugeben.",
  number_of_floors_paragraph: ``,
  heated_area_floor: `Prozentualer Anteil der beheizten Fläche im `,
  floor: `Stock`,
  provide_your_proper_information: `Geben Sie Ihre korrekten Informationen an.`,
  structure_details_para: `Um den Energiebedarf der Immobilie genau zu ermitteln, benötigen wir von Ihnen Informationen über die Gebäudeform.`,
  structure_details_para_note: `Bitte geben Sie lediglich die Form und Außenmaße Ihres Gebäudeteils an.`,
  wall_length: `Wand Länge `,
  corners: `Ecken`,
  custom: `Benutzerdefiniert`,
  total_floor_height: `Durchschnittliche Geschosshöhe (inkl. Deckenstärke)
`,
  living_space: `Wohnfläche (nicht Gebäudefläche)`,
  construction_type: `Bauart`,
  material_used: `Verwendeter Baustoff`,
  part_the_building: `Teil des Gebäudes`,
  type_of_ventilation: `Art der Belüftung`,
  exhaust_air_system: `Abluftsystem`,
  without_heat_recovery: `Lüftungsanlage ohne Wärmerückgewinnung`,
  with_heat_recovery: `Lüftungsanlage mit Wärmerückgewinnung`,
  shaft_ventilation: `Schachtbelüftung`,
  windows_ventilation: `Fensterlüftung`,
  cooling_system: `Gibt es ein Kühlsystem?`,
  yes: "Ja",
  no: "Nein",
  from_electricity: `elektrisch gekühlt`,
  delivered_cold: `bereits kalt an das Objekt geliefert`,
  passive_cooling: `Passive Kühlung`,
  cooling_from_heat: `Kühlung durch Wärme`,
  has_leaks_been_conducted: `Wurde ein Test auf undichte Stellen durchgeführt (Blower Door Test)?`,
  compliance_with_tightness: `Übereinstimmung mit der Dichtheit`,
  without_leak_test: `Ohne Dichtheitsprüfung`,
  obvious_leaks: `Offensichtliche Lecks`,
  other: `Andere`,
  required_field_error: `Dieses Feld ist erforderlich`,
  roof: `Dach`,
  building_component_error: `Bitte geben Sie Details zum Abschnitt Fenster, Keller & Isolierung an`,
  roof_shape: `Dachform`,
  flat_roof: `Flachdach`,
  gable_roof: `Giebeldach`,
  hip_roof: `Walmdach`,
  pult_roof: `Pultdach`,
  walm_flat: `Walm- und Flachdach (Kombination)`,
  structure: `Struktur`,
  attic: `Dachboden`,
  attic_type: `Dachboden Typ`,
  attic_height: `Dachgeschoss Höhe`,
  roof_pitch: `Dachneigung`,
  ridge_length: `Länge des Firstes`,
  ridge_width: `Breite des Firstes`,
  is_there_second_attic: `Gibt es ein zweites Dachgeschoss?`,
  is_there_second_attic_heated: `Gibt es einen zweiten beheizten Dachboden`,
  second_attic_height: `Zweite Dachgeschosshöhe`,
  knee_wall_or_sill: `Hat die Immobilie eine Kniewand oder Schwelle`,
  knee_wall_sill_height: `Kniestock (alternativ: Schwellenhöhe)`,
  window: `Fenster`,
  window_top_para_1: `Um präzise Angaben zum Energiebedarf zu erhalten, ist es empfehlenswert, die Abmessungen sämtlicher Fenster zu erfassen.`,
  have_dimensions_window: `Haben Sie die Abmessungen der einzelnen Fenster?`,
  windows_in_wall: `Bitte geben Sie alle Fenster in der Wand ein`,
  window_top_para_2: `Bitte geben Sie alle Fenster in allen Wänden ein. Sie können weitere Fenster hinzufügen, indem Sie das Plus-Symbol (+) unten verwenden. Achten Sie darauf, dass Sie die Fenster in jeder Wand einzeln eingeben.`,
  window_top_para_3:
    "Da Sie nicht über die Abmessungen aller Fenster verfügen, können Sie den ungefähren Prozentsatz der von den Fenstern belegten Wand angeben. Bitte versuchen Sie, die Angaben so genau wie möglich zu machen.",
  wall: `Wand`,
  window_type: `Fenster Typ`,
  window_area_wall: `Prozentualer Anteil der Fensterfläche an der Gebäudehülle`,
  type: `Typ`,
  length: `Länge`,
  width: `Breite`,
  count: `Zählen Sie`,
  basement: `Untergeschoss`,
  below_ground_floor: `Was verbirgt sich unter dem Erdgeschoss?`,
  floor_slab: `Bodenplatte`,
  insulation: `Isolierung`,
  property_insulated: `Ist die Immobilie gedämmt?`,
  exterior_walls: `Äußere Wände`,
  roof_or_top_ceiling: `Dach oder Oberkante der Decke`,
  floor_basement: `Stockwerk / Untergeschoss`,
  basement_walls: `Keller-Wände`,
  heating_system_installed: `Wie viele Heizungsanlagen sind installiert?`,
  energy_source: `Energiequelle`,
  heating_system: `Heizungsanlage`,
  year_1st_heating_installed: `Jahr der Installation des ersten Heizungssystems`,
  year_2nd_heating_installed: `Jahr der Installation des 2. Heizungssystems`,
  year_3rd_heating_installed: `Jahr der Installation des 3. Heizungssystems`,
  year_4th_heating_installed: `Jahr der Installation des 4. Heizungssystems`,
  distribution_heating: `Wärmeverteilung`,
  share_heating: `Anteil am Warmwassserverbrauch`,
  hot_water_system_installed: `Wie viele Warmwassererzeuger sind installiert?`,
  water_heating: `Warmwassererzeuger`,
  year_1st_water_installed: `Jahr der Installation des ersten Warmwassererzeugers`,
  year_2nd_water_installed: `Jahr der Installation des 2. Warmwassererzeugers`,
  year_3rd_water_installed: `Jahr der Installation des 3. Warmwassererzeugers`,
  year_4th_water_installed: `Jahr der Installation des 4. Warmwassererzeugers`,
  renewable_energy: `Werden erneuerbare Energien genutzt?`,
  unheated_basement: `Unbeheizter Keller`,
  heated_cellar: "Beheizter Keller",
  no_basement: "Kein Keller",
  photovoltaics: `Photovoltaik`,
  heat_pump: `Wärmepumpe`,
  biomass: `Biomasse`,
  house_number: `Straße und Hausnummer`,
  location: `Stadt`,
  postcode: `Postleitzahl`,
  billing_house_number_para_1: `Bitte geben Sie die Adresse an, die auf der Rechnung erscheinen soll. Wenn Sie die optionale Postzustellung wählen, senden wir Ihren Energieausweis auch an diese Adresse.`,
  billing_house_number_para_2: `Sollten Sie abweichende Adressen für den Versand und die Rechnung benötigen, geben Sie bitte die zusätzliche Adresse im Kommentarfeld an oder wenden Sie sich direkt an unseren Kundenservice.`,
  billing_house_number_para_3: `Wenn Ihre Adresse im Ausland liegt, können Sie auch eine ausländische Adresse angeben. Wir liefern auch ins Ausland.`,
  direction_object_point: `In welche Himmelsrichtung zeigt die Seite A des Objekts?  `,
  property_another_house: `Liegt das Grundstück neben einem anderen Haus?`,
  title_file_upload: `Informationen zum Hochladen von Dateien`,
  description_file_upload: `Seit Mai 2021 schreibt das Gebäudeenergiegesetz (GEG) vor, dass detaillierte Bilder des Sanierungszustands, der Gebäudehülle und der Anlagentechnik (z.B. Wärmeerzeuger) eingereicht werden müssen. Auf dem Energieausweis wird jedoch nur das Bild des Gebäudes gezeigt.`,
  photo_heater: `Foto der Heizung`,
  photo_building: `Foto des Gebäudes`,
  energy_certificate_available: `Ihr Energieausweis ist jetzt verfügbar`,
  energy_certificate_available_para_1: `Hier ist Ihre Vorschau des Energieausweises mit den genannten Daten.`,
  energy_certificate_available_para_2: `Bitte überprüfen Sie noch einmal alle Daten und klicken Sie dann auf `,
  energy_certificate_available_para_3: `Die Werte wurden lediglich anhand eines Näherungsverfahrens berechnet. Bitte beachten Sie, dass es sich hierbei nicht um den endgültigen Energieausweis handelt. Sie erhalten den registrierten und rechtsgültigen Energieausweis, nachdem wir Ihre Angaben geprüft haben.`,
  energy_certificate_available_box_1: `GEG-konform · 10 Jahre gültig`,
  energy_certificate_available_box_2: `Zertifizierte Energieberater`,
  energy_certificate_available_box_3: `Sofortversand: PDF & Rechnung`,
  energy_certificate_available_box_4: `Sichere Zahlung`,
  energy_certificate_available_box_5: `GREENOX GmbH`,
  energy_certificate_available_pdf_check_your_details: `Bitte prüfen Sie Ihre Angaben. Nach Abschluss der Zahlung erhalten Sie Ihren unterschriebenen und offiziell registrierten Energieausweis inkl. QR-Code.`,
  energy_certificate_available_pdf_progress_bar: `95 % abgeschlossen – nur noch 1 Schritt`,
  energy_certificate_available_pdf_sidebar_section_1_title: `Das erhalten Sie mit dem Kauf`,
  energy_certificate_available_pdf_sidebar_section_1_check_1: `✅ Offizieller Energieausweis (PDF) mit QR-Code`,
  energy_certificate_available_pdf_sidebar_section_1_check_2: `✅ Manuelle Prüfung durch zertifizierte Energieberater`,
  energy_certificate_available_pdf_sidebar_section_1_check_3: `✅ Rechnung & Nachweis für Behörden`,
  energy_certificate_available_pdf_sidebar_section_1_check_4: `✅ Speicherung & kostenlose Korrektur bei Bedarf`,
  energy_certificate_available_pdf_sidebar_section_2_title: `Ihr Energieverbrauch wirkt zu hoch?`,
  energy_certificate_available_pdf_sidebar_section_2_para_part_1: `Keine Sorge – das ist häufig der Fall. Die Berechnung nutzt realistische Durchschnittswerte nach GEG.`,
  energy_certificate_available_pdf_sidebar_section_2_para_part_2: `Wir prüfen jeden Ausweis manuell`,
  energy_certificate_available_pdf_sidebar_section_2_para_part_3: `bevor er registriert wird.`,
  energy_certificate_available_pdf_sidebar_section_2_info: `Bei Altbauten ohne Sanierungen sind Werte über 150 kWh/m²a normal. Baujahr, Heizung und Dämmung beeinflussen den Kennwert stark.`,
  energy_certificate_available_pdf_sidebar_section_2_checkbox_1: `Der berechnete Wert erscheint mir realistisch`,
  energy_certificate_available_pdf_sidebar_section_2_checkbox_2: `Ich finde den Wert zu hoch – bitte prüfen Sie das`,
  energy_certificate_available_pdf_sidebar_section_2_checkbox_3: `Ich möchte eine Rückmeldung vor der finalen Ausstellung`,
  energy_certificate_available_pdf_sidebar_section_2_feedback: `Ihre Hinweise (optional)`,
  i_reviewed_entries: `Ich habe meine Eingaben überprüft und keine Fehler gefunden. Alle Hinweise habe ich unter „Anmerkungen & Dokumente“ ergänzt.`,
  order_type: `Art der Bestellung`,
  order_type_paragaraph: `Bitte wählen Sie aus, ob Sie die Bestellung als Privatperson oder als Unternehmen veranlassen. Wenn Sie als Gewerbetreibender mit einer Umsatzsteuer-Identifikationsnummer bestellen, wählen Sie „Gewerblich“. Wenn Sie als Unternehmer ohne Umsatzsteuer-Identifikationsnummer bestellen, wählen Sie entweder „Privat“ oder „Gewerblich ohne Umsatzsteuer-Identifikationsnummer“.`,
  private_owners: `Privat`,
  commercial: `Gewerblich (mit USt-ID)`,
  commercial_ustId: `Gewerblich (ohne USt-ID)`,
  phone_number: `Telefonnummer`,
  first_name: `Vorname`,
  surname: `Nachname`,
  add_on_services: `Zusätzliche Dienstleistungen`,
  certificate_packages_title: `Zertifikat-Pakete`,
  certificate_packages_description: `Kaufen Sie mehrere Zertifikate im Voraus und sparen Sie!`,
  postal_dispatch_invoices: `Postversand von Energieausweis & Rechnung`,
  express_exhibition_today: `Express-Ausstellung heute`,
  advanced_verification: `Erweiterte Verifizierung (empfohlen)`,
  free_correction_option: `Korrekturmöglichkeit, wenn falsche Informationen entdeckt werden`,
  experts_explain: `Persönliches 30 Minuten Telefonat, um Fragen zu beantworten`,
  delivery_method: `Liefermethode des Energieausweises (Liefermethode der ID-Karte)`,
  delivery_method_2: `Versandart des Ausweises (gedruckte Kopie per Post und digital per E-Mail)`,
  custom_structure: `Benutzerdefinierte Gebäudeform`,
  note: "Hinweis",

  solid_construction: "Massivbauweise",
  wooden_construction: "Holzbauweise",
  pre_fabricated: "Fertighaus",
  total_building: "Gebäude insgesamt",
  residential_part: "Wohnteil eines gemischten Gebäudes",
  solid_ceiling: "solide Decke",
  wooden_ceiling: "Holzdecke",
  heated_attic: "Beheizter Dachboden",
  unheated_attic: "Unbeheizter Dachboden",
  heating_percentage: "Prozentsatz der beheizten Fläche",
  heated_percentage_second: "Heizungsprozentsatz des zweiten Dachgeschosses",
  heated_part_basement: "Beheizter Teil des Untergeschosses",
  continue: "Weiter.",
  billing_house_number: `Straße & Hausnummer`,
  construction_year_error: "Das Jahr muss zwischen 1850 und",
  invalid_data_error: "Dieses Feld sollte kein '-', 'e' oder '+' enthalten.",
  field_required: "Dieses Feld ist erforderlich",
  invalid_year_of_construction_error:
    "Ungültiges Jahr, bitte geben Sie einen numerischen Wert ein.",
  invalid_contain: "sollte kein '-', 'e' oder '+' enthalten.",
  not_valid_num: "keine gültige Telefonnummer",
  image_error:
    "Um sicherzustellen, dass es sich um die beschriebene Heizung handelt, benötigen wir ein Foto.",
  common_error: `Dieses Feld darf nicht leer sein`,

  Occasion_head: "Anlass",
  Occasion_desc: `Benötigen Sie den Energieausweis für eine Finanzierung oder einen Kreditantrag? Dann wählen Sie bitte „Andere“ als Ausstellungsgrund. Energieausweise mit dem Ausstellungsgrund „Neubau“ oder „Modernisierung“ können nicht gemäß § 80 GEG erstellt werden.`,
  build_head: "Gebäudetyp",
  build_desc: `Für gemischt genutzte Gebäude empfehlen wir einen Bedarfsausweis, da dieser genauere Ergebnisse liefert.
  „Doppelhaus“ hinzufügen
  Zwei aneinandergebaute, getrennt nutzbare Wohneinheiten mit eigener Heizung.`,
  num_aprt: "Anzahl der Wohnungen",
  num_aprtdesc: `Energieausweise gelten für das gesamte Gebäude. Einliegerwohnungen zählen als eigene Einheit. Bei Einfamilienhäusern bitte „1“ angeben.`,
  num_floor: "Anzahl der Etagen (ohne Keller und Dachgeschoss)",
  email: "E-Mai",
  e_para_1: `Bitte geben Sie eine gültige E-Mail-Adresse an. Darüber erhalten Sie Ihre`,
  e_para_2: `Auftragsbestätigung und Rechnung. Wir kontaktieren Sie dort auch bei Rückfragen.`,
  floor_ceiling: "Boden bis zur Decke Höhe",
  Energy_h: "Energiequelle",
  Energy_d: "Bitte wählen Sie hier Ihre Hauptenergiequelle",
  date_h: "Dat",
  date_d: `„Um einen Verbrauchsausweis zu beantragen, müssen die Verbrauchswerte der letzten drei Jahre vorliegen, d.h. der erste Abrechnungszeitraum muss mindestens drei Jahre zurückliegen. Tragen Sie hier den Monat und das Jahr des Beginns des ersten Abrechnungszeitraums ein.`,
  consmCount_h: "Verbrauch",
  consmCount_d1: `Bitte geben Sie hier den Gesamtenergieverbrauch für jeden Zeitraum an. Ein Abrechnungszeitraum ist immer ein Jahr lang.`,
  consmCount_d2: `Bei Mehrfamilienhäusern sollten Sie den Gesamtenergieverbrauch des gesamten Gebäudes angeben, da sich Energieausweise immer auf das gesamte Gebäude beziehen.`,
  consmCount_d3: `Wenn es sich um eine Kraft-Wärme-Kopplungsanlage (BHKW) handelt, geben Sie bitte nur die erzeugte Wärmemenge (ohne Strom) an.`,
  unit_h: "Einheit",
  unit_d1: `Bitte geben Sie die korrekte Verbrauchseinheit des Energieträgers/Brennstoffs ein.`,
  unit_d2: `Diese können Sie in der Regel auf Ihrer Heizkostenabrechnung finden.`,
  include_h:
    "Diese können Sie in der Regel auf Ihrer Heizkostenabrechnung finden.",
  include_d: `Bitte geben Sie hier an, ob der Warmwasser-Energieverbrauch bereits in dem oben angegebenen Verbrauch enthalten ist oder nicht. Sie können den Warmwasser-Energieverbrauch auch separat angeben.`,
  system_h: "Ist Warmwasser im Heizsystem inbegriffen",
  system_d: `Geben Sie hier den Anteil der Warmwasserversorgung an. Der Standardwert ist 18%.`,
  vacancy_h: "Prozentsatz der offenen Stellen",
  vacancy_d1: `Bitte geben Sie die Leerstandsquote in % für ein ganzes Jahr und für das gesamte Gebiet an.`,
  vacancy_d2: `Berechnung der Leerstandsquote Sie addieren die Leerstandsquote über die Monate und teilen diese durch 12. Dann multiplizieren Sie den Wert mit 100 und Sie erhalten den Prozentsatz.`,
  vacancy_d3: `Beispiel: Wenn die Immobilie innerhalb von 12 Monaten 3 Monate lang leer steht, wären dies 25 %. Berechnung: 3 / 12 * 100 = 25%`,
  install_h: "Baujahr der Heizungsanlage",
  install_d: `Das Baujahr der Heizungsanlage finden Sie im Abgasmessprotokoll, in der Betriebsanleitung, auf dem Typenschild, im Abnahmeprotokoll usw. Wenn Sie Fernwärme nutzen, geben Sie bitte das Baujahr der Fernwärmeübergabestation an. Wenn Ihr Kessel modernisiert wurde, geben Sie bitte das Jahr der Modernisierung an. Das Jahr, in dem der Brenner modernisiert wurde, ist nicht relevant. Wenn Sie mehrere Geräte haben, geben Sie bitte das überwiegende Baujahr an.`,
  ventilation_h: "Art der Belüftung",
  ventilation_d: `Wie wird das Gebäude belüftet? Beispiele für Lüftungsanlagen ohne Wärmerückgewinnung sind Abluftanlagen in fensterlosen Räumen wie Badezimmern. Lüftungsanlagen mit Wärmerückgewinnung sind zum Beispiel zentrale oder dezentrale Zu- und Abluftanlagen, die mit Wärmetauschern ausgestattet sind.`,
  livingSpace_h: "Wohnfläche (nicht Gebäudefläche)",
  livingSpace_d: `Der Energieausweis ist immer auf das jeweilige Gebäude bezogen. Wir bitten Sie daher, die Wohnfläche des gesamten Gebäudes (ohne Keller) in Quadratmetern anzugeben. Anhand dieser Angaben wird die Nutzfläche des Gebäudes im Energieausweis automatisch berechnet.`,
  building_h: "Gebäudeteil",
  building_d1: `Nur als „gemischt genutzt“ markieren, wenn Wohn- und Gewerbeflächen nicht klar überwiegen (<90 %). Kein Energieausweis für Nichtwohngebäude.`,
  building_d2: `Außerdem kann ein gemeinsamer Energieausweis ausgestellt werden, wenn sich die Heizungsanlage nicht wesentlich unterscheidet.`,
  building_d3: `Wir stellen derzeit keine Energieausweise für Nichtwohngebäude aus.`,
  thermal_h: "Wurde die Wärmeschutzverordnung von 1977 eingehalten?",
  number_h: "Straße und Hausnummer",
  number_d1: `Bitte geben Sie die Adresse des Gebäudes an, für das der Energieausweis erstellt werden soll.`,
  number_d2: `Im nächsten Schritt können Sie die Rechnungs- und Lieferadresse eingeben.`,
  Postcode_h: "Postleitzahl",
  Postcode_d1: `Bitte geben Sie die Adresse des Gebäudes an, für das der Energieausweis erstellt werden soll`,
  Postcode_d2: `Im nächsten Schritt können Sie die Rechnungs- und Lieferadresse eingeben.`,
  Location_h: "Stadt",
  Location_d1: `Bitte geben Sie die Adresse des Gebäudes an, für das der Energieausweis erstellt werden soll.`,
  Location_d2: `Im nächsten Schritt können Sie die Rechnungs- und Lieferadresse eingeben.`,
  order_h: "Typ bestellen",
  order_d: `Bitte wählen Sie aus, ob Sie den Antrag als Privatperson oder als Unternehmen einreichen. Wenn Sie als Gewerbetreibender mit einer Umsatzsteuer-Identifikationsnummer bestellen, wählen Sie „Gewerblich“. Wenn Sie als Unternehmer ohne Umsatzsteuer-Identifikationsnummer bestellen, wählen Sie entweder „Privat“ oder „Gewerblich ohne Umsatzsteuer-Identifikationsnummer“.`,
  address_d1: `Bitte geben Sie die Adresse an, die auf der Rechnung erscheinen soll. Wenn Sie die optionale Postzustellung wählen, senden wir Ihren Energieausweis auch an diese Adresse.`,
  address_d2: `Sollten Sie abweichende Adressen für den Versand und die Rechnung benötigen, geben Sie bitte die zusätzliche Adresse im Kommentarfeld an oder wenden Sie sich direkt an unseren Kundenservice.`,
  address_d3: `Wenn Ihre Adresse im Ausland liegt, können Sie auch eine ausländische Adresse angeben. Wir liefern auch ins Ausland.`,
  close_btn: "Schließen",
  notes_documents_button: "Anmerkungen & Dokumente",
  save_resume_later: "Speichern und später fortsetzen",
  next: `Weiter`,
  previous: "Zurück",
  type: "Typ",
  length: "Länge",
  width: "Breite",
  count: "Zählen",
  no_of_floor: `Anzahl der Etagen (ohne Keller und Dachgeschoss)`,
  no_of_floors_info: `Nur vollwertige Wohnetagen zählen. Keller und Dachgeschosse mit Schrägen werden separat abgefragt.`,
  per_first_floor: `Prozentualer Anteil der beheizten Fläche im 1.`,
  per_first_floor_info: `Bitte geben Sie den Anteil der beheizten Fläche im jeweiligen Stockwerk an`,
  avg_height: `Mittlere Vollgeschosshöhe (inkl. Deckenstärke)`,
  avg_height_info: `Die Geschosshöhe ist der Abstand von der Oberfläche eines Bodens bis zur Oberfläche des darüberliegenden Bodens`,
  living_sp: `Wohnfläche (nicht Gebäudefläche)`,
  living_sp_info1: `Der Energieausweis ist immer mit dem jeweiligen Gebäude verknüpft. Wir bitten Sie daher, die Wohnfläche des gesamten Gebäudes (ohne Keller) in Quadratmetern anzugeben. `,
  living_sp_info2: `Basierend auf diesen Informationen wird die Nutzfläche des Gebäudes automatisch im Energieausweis berechnet.`,
  type_con: `Bauart`,
  type_con_info: `Bitte geben Sie die Bauart, welche auf Ihre Immobilie zutrifft, an. Wenn es verschiedene Bauweisen gibt, geben Sie bitte die überwiegende an.`,
  material: `Verwendeter Baustoff`,
  material_info1: `Bitte geben Sie die Art der Bauweise im Detail an.`,
  material_info2: `Wenn Sie eine zusätzliche Dämmung besitzen, können Sie diese im nächsten Schritt angeben. Falls Sie Ihr Außenmaterial nicht aus der Liste auswählen können oder Sie den genauen U-Wert kennen, senden Sie uns gerne den U-Wert zu.`,
  part_of_build: `Teil des Gebäudes`,
  part_of_build_info: `Wenn in dem Gebäude sowohl Gewerbeflächen als auch Wohnungen untergebracht sind, müssen 2 getrennte Energieausweise ausgestellt werden, wenn der Anteil der Wohnungen weniger als 90% der Fläche beträgt. Ist der Wert geringer, muss "Wohngebäude" ausgewählt werden. Des Weiteren kann ein gemeinsamer Energieausweis ausgestellt werden, wenn sich die Heizungsanlage nicht wesentlich unterscheidet. Für Nichtwohngebäude stellen wir ebenfalls Energieausweise aus. Bitte schreiben Sie uns hierzu eine E-Mail an info@greenox-group.de`,
  type_ventilation: `Art der Belüftung`,
  type_ventilation_info: `Wie wird das Gebäude belüftet? Beispiele für Lüftungsanlagen ohne Wärmerückgewinnung sind Abluftanlagen in Räumen ohne Fenster, wie z.B. Badezimmer. Zu den Lüftungsanlagen mit Wärmerückgewinnung zählen beispielsweise zentrale oder dezentrale Zu- und Abluftanlagen, die mit Wärmetauschern ausgestattet sind.`,
  colling: `Gibt es ein Kühlsystem?`,
  colling_info: `Wird das Gebäude im Sommer aktiv gekühlt (z. B. durch Klimaanlage)`,
  door_test: `Wurde ein Test auf undichte Stellen durchgeführt (Blower Door Test)?`,
  door_test_info: `Bitte geben Sie an, ob ein Blower Door Test zur Messung der Luftdichtheit durchgeführt wurde`,
  shape: `Dachform`,
  window_install_year: `"Bitte geben Sie alle Fenster in der Wand ein `,
  shape_info: `Bitte teilen Sie uns die Dachform Ihres Gebäudes mit. Sollte Ihr Gebäude eine abweichende Dachform haben, wählen Sie bitte „Satteldach“ aus und hinterlegen Sie die Informationen zur Dachform in den Anmerkungen. `,
  structure: `Struktur`,
  structure_info: `Bitte geben Sie an, ob Ihr Gebäude massiv (kein Holz) oder aus Holz gebaut ist. Flachdächer sind in der Regel massiv (nicht aus Holz) und Satteldächer meist als Holzbau errichtet.`,
  type: `Typ`,
  type_info: `Bitte wählen Sie die Art der Verglasung und das Material des Fensterrahmens aus.
`,
  length: `Länge (in Metern)`,
  length_info: `Bitte geben Sie die Länge des Fensters in Metern an`,
  width: `Breite (in Metern)`,
  width_info: `Bitte geben Sie die Breite des Fensters in Metern an`,
  count: `Anzahl der Fenster`,
  count_info: `Bitte geben Sie die Anzahl der Fenster an dieser Wand an, die die gleiche Länge und Breite haben`,
  window_type: `Fenster Typ`,
  window_type_info: `Bitte wählen Sie die Art der Verglasung und das Material des Fensterrahmens aus.
`,
  per_window: `Prozentualer Anteil der Fensterfläche an der Gebäudehülle`,
  per_window_info: `Angabe des prozentualen Anteils der Fensterfläche an der ausgewählten Wand`,
  under_1st: `Was verbirgt sich unter dem Erdgeschoss?`,
  under_1st_info1: `Bitte geben Sie an, ob ein Keller vorhanden bzw. auch beheizt ist. Beheizt bedeutet hier, dass sich in einem überwiegenden Teil der Räume Heizkörper befinden. Dabei spielt es keine Rolle, ob Sie diese anschalten oder nicht.`,
  under_1st_info2: `Sollte nur der Heizungsraum indirekt beheizt werden, so zählt dies nicht als beheizter Keller.`,
  slab: `Bodenplatte`,
  slab_info: `Bitte geben Sie die Bauweise der Bodenplatte gegen Erdreich an.`,
  insulated: `Ist die Immobilie isoliert?`,
  ex_walls: `Dämmung (Außenwände) - in zentimeter`,
  ex_walls_info: `Bitte geben Sie an, ob Ihre Außenwände gedämmt sind. Geben Sie die durchschnittliche Dicke der Dämmung OHNE die Konstruktionsschicht an.`,
  top_roof: `Dämmung (Dach oder oberste Decke) - in zentimeter`,
  top_roof_info: `Bitte geben Sie hier an, ob und wie stark Ihr Dach bzw. die oberste Geschossdecke (Dachgeschoss) gedämmt sind. Wenn beide Gebäudeteile gedämmt sind, geben Sie die stärkere Dämmung an. Bitte geben Sie nur die Dämmung an.`,
  celler: `Dämmung (Fußboden / Keller) - in zentimeter`,
  celler_info1: `Bitte geben Sie an, ob und wie stark Ihre Kellerdecke oder die Bodenplatte gedämmt ist. Wenn beide Gebäudeteile gedämmt sind, geben Sie bitte die stärkere Dämmung an. Beachten Sie, nur die Dämmung anzugeben.`,
  celler_info2: `Sollten Sie über eine Trittschalldämmung verfügen, teilen Sie uns diese bitte ebenfalls mit.`,
  base_walls: `Dämmung (Kellerwände) - in zentimeter`,
  base_walls_info: `Bitte geben Sie hier an, ob und wie stark Ihre Kellerwände gedämmt sind. Bitte geben Sie Dämmung in Zentimeter an.`,
  source: `Energiequelle`,
  source_info: `Hauptenergiequelle für Heizung auswählen. Bei mehreren bitte die dominierende Energieart wählen.`,
  unit: `Einheit`,
  unit_info: `Bitte geben Sie die korrekte Verbrauchseinheit des Energieträgers/Brennstoffs ein. Diese finden Sie in der Regel auf Ihrer Heizkostenabrechnung.`,
  date: `Datum`,
  date_info: `Für die Beantragung eines Verbrauchsausweises müssen Verbrauchswerte der letzten drei Jahre vorliegen – das heißt, der erste Abrechnungszeitraum muss mindestens drei Jahre zurückliegen. Geben Sie hier den Monat und das Jahr des Beginns des ersten Abrechnungszeitraums ein`,
  heating_system_installed_on_paragraph: `Das Baujahr der Heizungsanlage finden Sie im Abgasmessprotokoll, in der Betriebsanleitung, auf dem Typenschild, im Abnahmeprotokoll usw. Wenn Sie Fernwärme nutzen, geben Sie bitte das Baujahr der Fernwärmeübergabestation an. Wenn Ihr Kessel modernisiert wurde,  geben Sie bitte das Jahr der Modernisierung an. Das Jahr, in dem der Brenner modernisiert wurde, ist nicht relevant. Wenn Sie mehrere Geräte haben, geben Sie bitte das überwiegende Baujahr an.`,
  number_h: "Straße und Hausnummer",
  number_d1: `Bitte geben Sie die Adresse des Gebäudes an, für das der Energieausweis erstellt werden soll.`,
  number_d2: `Im nächsten Schritt können Sie die Rechnungs- und Lieferadresse eingeben.`,
  postcode: `Postleitzahl`,
  postcode_para_1: `Bitte geben Sie die Adresse des Gebäudes an, für das der Energieausweis erstellt werden soll.`,
  postcode_para_2: `Im nächsten Schritt können Sie die Rechnungs- und Lieferadresse eingeben.`,
  build_photo: `Foto des Gebäudes`,
  build_photo_info: `Bitte laden Sie ein aktuelles Foto der Gebäudefassade hoch (Vorderansicht). Dieses erscheint im Energieausweis. Formate: JPG, PNG, PDF – max. 10 MB.`,
  order_type: `Art der Bestellung`,
  order_type_paragaraph: `Bitte wählen Sie aus, ob Sie die Bestellung als Privatperson oder als Unternehmen veranlassen. Wenn Sie als Gewerbetreibender mit einer Umsatzsteuer-Identifikationsnummer bestellen, wählen Sie „Gewerblich“. Wenn Sie als Unternehmer ohne Umsatzsteuer-Identifikationsnummer bestellen, wählen Sie entweder „Privat“ oder „Gewerblich ohne Umsatzsteuer-Identifikationsnummer“.`,
  billing_house_number: `Straße & Hausnummer`,
  billing_house_number_para_1: `Bitte geben Sie die Adresse an, die auf der Rechnung erscheinen soll. Wenn Sie die optionale Postzustellung wählen, senden wir Ihren Energieausweis auch an diese Adresse.`,
  billing_house_number_para_2: `Sollten Sie abweichende Adressen für den Versand und die Rechnung benötigen, geben Sie bitte die zusätzliche Adresse im Kommentarfeld an oder wenden Sie sich direkt an unseren Kundenservice.`,
  billing_house_number_para_3: `Wenn Ihre Adresse im Ausland liegt, können Sie auch eine ausländische Adresse angeben. Wir liefern auch ins Ausland.`,
  eMail: `E-Mail`,
  eMail_para_1:
    "Bitte geben Sie eine gültige E-Mail-Adresse an, damit wir Sie kontaktieren können, wenn wir Fragen zu Ihren Angaben haben.",
  eMail_para_2:
    "Sie erhalten auch die Auftragsbestätigung und die Rechnung über die von Ihnen angegebene E-Mail-Adresse.",
  attic: `Dachboden`,
  attic_info: `Geben Sie bitte die Bauweise Ihres Dachgeschosses an (oberste Geschossdecke). Meist sind Holzbalkendecken vorhanden. Wenn dies bei Ihnen abweicht, geben Sie bitte "massive Decke" an.`,
  attic_type: `Dachboden Typ`,
  attic_type_info1: `Geben Sie bitte an, ob Ihr Dachgeschosses entweder direkt oder durch einen Luftverbund beheizt ist. Ist das Dachgeschossen nur teilweise beheizt, so geben Sie bitte beheizt an.`,
  attic_type_info2: `In diesem Kontext bezieht sich das Wort "Dachgeschoss" auf das erste Stockwerk das schräge Decken hat.`,
  roof_p: `Dachneigung`,
  roof_p_info: `Bitte geben Sie die Neigung Ihres Daches in Grad an. Die Dachneigung beschreibt den Winkel, den die Dachfläche zur Horizontalen bildet.`,
  Attic_Height: `Dachgeschosses Höhe`,
  Attic_Height_info1: `Geben Sie hier die Höhe des Dachgeschosses an. Die Dachgeschosshöhe ist der Abstand zwischen der Oberkante des Fußbodens und der Unterkante der Dachkonstruktion.`,
  Attic_Height_info2: `Sollten Sie sich unsicher sein, drücken Sie bitte "Dachgeschosshöhe ermitteln". Wir werden anschließend anhand Ihrer Gebäudeangaben die Dachgeschosshöhe für Sie berechnen.`,
  Attic_Height_info3: `Bitte geben Sie die Höhe des Dachgeschosses an. Sollte ein Dach- bzw. Spitzboden vorhanden sein, geben Sie bitte nur die Höhe der unteren Ebene an und erfassen den Spitzboden als 2. Dachgeschoss.`,
  sec_attic: `Gibt es ein zweites Dachgeschoss?`,
  sec_attic_info: `Ein 2. Dachgeschoss ist ein zusätzliches Geschoss, das im Dachgeschoss eines Hauses untergebracht ist. Es ist eine Erweiterung des normalen Dachgeschosses, das üblicherweise als Wohnraum oder als Abstellfläche genutzt wird.`,
  sec_attic_heat: `Gibt es einen zweiten beheizten Dachboden`,
  sec_attic_heat_info: `Geben Sie bitte an, ob Ihr Dachboden (kleineres Dachgeschoss) entweder direkt oder durch einen Luftverbund beheizt ist. Ist das Dachgeschossen nur teilweise beheizt, so geben Sie bitte beheizt an.In diesem Kontext bezieht sich das Wort "Dachgeschoss" auf das höchste Stockwerk das schräge Decken besitzt. Andere Bezeichnungen wären Spitzboden oder Dachboden.`,
  sec_attic_per: `Heizungsprozentsatz des zweiten Dachgeschosses`,
  sec_attic_per_info: `Geben Sie den prozentualen Anteil der zweiten Dachbodenfläche an (bezogen auf die Bodenfläche des Dachbodens)`,
  sec_attic_height: `Zweite Dachgeschosshöhe`,
  sec_attic_height_info: `Bitte geben Sie die Höhe des Dachbodens über dem größeren Dachgeschoss an. Messen Sie dazu die Entfernung von der Oberkante des Bodens bis zum höchsten Punkt des Dachs, normalerweise die Firstpfette.`,
  sill: `Hat die Immobilie eine Kniewand oder Schwelle`,
  sill_info: `Ein Kniestock ist ein Wandabschnitt, der zwischen dem obersten Geschoss und dem Dach eines Hauses liegt
Der Kniestock befindet sich in der Regel unterhalb des obersten Geschosses und erstreckt sich bis zur Dachkonstruktion. Die Außenwand, die die Luft berührt, ist hier relevant. Die innere Abmauerung oder Ähnliches ist nicht maßgebend.`,
  sill_height: `Kniestock (alternativ: Schwellenhöhe)`,
  heater_photo: `Foto der Heizung`,
  heater_photo_info1: `Bitte laden Sie hier Fotos von Ihrem Wärmeerzeuger hoch.`,
  heater_photo_info2: `Sie können mehrere Fotos hochladen.`,
  heater_photo_info3: `Die Fotos sollten Ihre Angaben nachvollziehbar bestätigen. Hilfreich sind Fotos von Ihrer Heizungsanlage und Warmwasserbereitung (Typenschilder der Heizung UND Warmwasserbereitung), aber auch zusätzlich die Fotos der Gerätschaften wie Heizungskessel, Heizkreispumpe, Warmwasser-Speicherung usw.`,
  heater_photo_info4: `Möglich sind auch Rechnungen oder Schornsteinfegerprotokolle, welche Ihre Heizungs-/Warmwasseranlage belegen.`,
  type_roof: "Dach",
  type_window: "Fenster",
  type_basement: "Untergeschoss",
  type_insulation: "Dämmung",
  company_name: `Name des Unternehmens`,
  VAT_ID: `UMSATZSTEUER-ID`,
  order_summary: `Zusammenfassung der Bestellung`,
  i_agree_text: `Ich bin mit den Allgemeinen Geschäftsbedingungen einverstanden und habe die Bestimmungen zum Datenschutz und zur Widerrufsbelehrung zur Kenntnis genommen`,
  terms_conditions: `Bedingungen und Konditionen`,
  privacy_policy: "Datenschutzbedingung",
  total: "Insgesamt",
  including: "inkl. 19% MwSt.",
  order_now: `Jetzt bestellen`,
  custom_info:
    "Zusätzliche Unterlagen wie Baupläne und Skizzen sind für unseren Energieberater hilfreich, um Ihre Gebäudestruktur zu verstehen.",
  custom_agree:
    "Ich erkläre mich damit einverstanden, dass für den Energieausweis dieses Gebäudes zusätzliche Gebühren anfallen, da das Gebäude keine Standardstruktur aufweist.",
  add_documents: "Dokumente und Notizen hinzufügen",
  sqm: "m²",

  not_found: "Seite nicht gefunden",
  something_wrong: `Irgendetwas ist schief gelaufen.<br/>
Bitte versuchen Sie es nach einiger Zeit erneut.`,
  support:
    "Wenn das Problem weiterhin besteht, wenden Sie sich bitte an den Support.",
  back_step: "Zurück zu Schritt 1",
  year: "liegen",
  partially_heated: "Ist ein Stockwerk nur teilweise beheitzt?",
  Documents_notes_btn: "Dokumente und Notizen hinzufügen",
  water_system: "Wie viele Heißwassersysteme sind installiert?",
  year_of: "Baujahr, in dem das  ",
  heating_install: " Heizungssystem installiert wurde",
  water_install: "Warmwassersystem wurde installiert",
  valid_number: "Keine gültige Nummer",
  select_option: "Bitte wählen Sie mindestens eine Option",
  link_head: "Probleme beim Hochladen von Dateien?",
  link_para:
    "Wenn Sie Schwierigkeiten beim Hochladen Ihrer Dateien haben oder Ihre Dokumente so groß sind, dass Sie uns einen Link zu einem Cloud-Dienst (wie Dropbox, Google Drive, OneDrive) schicken möchten, steht Ihnen nichts im Wege. Fügen Sie einfach den Link unten hinzu und geben Sie den Zugang mit der E-Mail-ID „info@greenox-group.de“ frei.",
  window_year: "Baujahr der Fenster",
  wall: `Welche Wand grenzt an ein anderes Haus?`,
  email_start: `Indem Sie fortfahren, akzeptieren Sie unsere`,
  concrete_construction: "Konstruktion aus Stahlbeton",
  wooden_construction: "Hölzerne Konstruktion",
  other: "Andere",
  energy_performance_text: "Energieausweis",
  certificate_residential_build: "Bedarfsbescheinigung für Wohngebäude",
  aggree: "Ich akzeptiere die ",
  proceed: "Bitte akzeptieren Sie die Datenschutzbestimmungen, um fortzufahren",
  faq: `Lesen Sie hier die häufig gestellten Fragen zu unserem Energieausweis-System`,
  percent_error: "Dieses Feld ist erforderlich",
  no_wall:
    "Diese Informationen erhalten wir aus den von Ihnen bereitgestellten Daten",
  height_val: `Die maximale Höhe muss kleiner als oder gleich 5 sein.`,
  payment_done: "Zahlung erfolgt",
  central_distribution: "Zentrale Verteilung",
  apartment_wise: "Verteilung auf die einzelnen Wohnungen",
  decentralized_distribution: "Dezentralisierte Verteilung",
  sub_total: "Zwischensumme",
  total: "Insgesamt",
  discount: "Coupon-Rabatt",
  copon_codes: "Coupon-Codes",
  off: "Aus",
  apply: "Anwenden",
  applied: "Angewandt",
  not_exist: "Ungültiger Gutscheincode",
  number_of_air_conditioning_systems: "Anzahl der zu überprüfenden Klimaanlagen",
  cooling_capacity: "Kühlleistung",
  next_inspection_date: "Datum der nächsten Inspektion",
  Heating_coverage_rate_in: "Deckungsanteil der Heizung in %",
  position_of_ventilation: " Position des Belüftungssystems"
};
export const successGerText = {
  heading: `Vielen Dank für Ihre Bestellung`,
  statusText: `Ihre Zahlung ist erfolgreich eingegangen.`,
  status_desc: `Wir haben Ihre Bestellung erhalten und werden mit der Prüfung beginnen, Sie erhalten Ihren Energieausweis auf die von Ihnen angegebene E-Mail.`,
  receipt: `Quittung`,
  invoice: `Rechnung`,
  order_id: "Bestellnummer",
  receipt: "Quittung",
  invoice: "Rechnung",
  sqm: "m²",
};
export const failureGerText = {
  heading: `Zahlung fehlgeschlagen - Maßnahmen erforderlich`,
  statusText: `Ihre Zahlung wurde nicht erfolgreich bearbeitet.`,
  status_desc: `Wir haben Ihre Bestellung erhalten, konnten aber die Zahlung nicht bearbeiten. Sobald die Zahlung erfolgreich abgewickelt wurde, werden wir mit der Bearbeitung Ihrer Bestellung beginnen und 
und senden den Energieausweis an die von Ihnen angegebene E-Mail-Adresse.`,
  retry_payment: `Wiederholung der Zahlung`,
  order_id: "Bestellnummer",
  retry: "Zahlung erneut versuchen",
};
